/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  FormGroup,
  TextArea,
  Button,
  DataTable,
  TableContainer,
  TableToolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  TableToolbarContent,
  TextInput,
  Tile,
  TimePicker,
  DatePicker,
  DatePickerInput,
} from 'carbon-components-react';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import Send16 from '@carbon/icons-react/lib/email/16';
import SimpleReactValidator from 'simple-react-validator';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import { entitiesLabels } from '../../../helpers/Constants';
import { NoRecordsPlaceholder } from '../../../helpers/jsonschemaform/DataTableExtention';
import AuditWorkSiteComboBox from './AuditWorkSiteComboBox';
import EmailChips from '../../../helpers/EmailChips';
import DateTimePicker from '../../../helpers/DateTimePicker';
import AuditModalSignature from './AuditModalSignature';

export default class AuditNotificationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationData: this.props.NotificationFormData,
      modalActivityDetailVisible: false,
      modalActivityDeleteVisible: false,
      modalDeleteRelatedDocumentVisible: false,
      modalRelatedDocumentDetailsVisible: false,
      editNotificationEmailVisible: false,
      flagTime: false,
      validateSend: true,
      selectedActivity: {
        id: null,
        auditor: null,
        activity: null,
        from: null,
        to: null,
        date: null,
      },
      selectedDocument: {
        name: null,
      },
    };
    this.onDistributionListModify = this.onDistributionListModify.bind(this);
    this.onResponsibleEmailModify = this.onResponsibleEmailModify.bind(this);
    this.handleActivityDetailVisibility = this.handleActivityDetailVisibility.bind(this);
    this.handleDeleteActivityModal = this.handleDeleteActivityModal.bind(this);
    this.handleDeleteRelatedDocumentModal = this.handleDeleteRelatedDocumentModal.bind(this);
    this.handleRelatedDocumentModalVisibility = this.handleRelatedDocumentModalVisibility.bind(
      this
    );
    this.onAuditorChanged = this.onAuditorChanged.bind(this);
    this.onTimeToChanged = this.onTimeToChanged.bind(this);
    this.onTimeFromChanged = this.onTimeFromChanged.bind(this);
    this.onActivityChanged = this.onActivityChanged.bind(this);
    this.onWorkSiteChanged = this.onWorkSiteChanged.bind(this);
    this.onSubmitActivity = this.onSubmitActivity.bind(this);
    this.onSubmitRelatedDocument = this.onSubmitRelatedDocument.bind(this);
    this.onActivityDateChange = this.onActivityDateChange.bind(this);
    this.onActivityDelete = this.onActivityDelete.bind(this);
    this.onRelatedDocumentDelete = this.onRelatedDocumentDelete.bind(this);
    this.saveNotificationForm = this.saveNotificationForm.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
    this.onMailCCModify = this.onMailCCModify.bind(this);
    this.onMailBodyModify = this.onMailBodyModify.bind(this);

    this.validator = new SimpleReactValidator({
      validators: {
        emails: {
          // name the rule
          message: 'The :attribute must be a valid email address list semicolon separated',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              // eslint-disable-next-line no-useless-escape
              /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
            ) && params.indexOf(val) === -1,
          required: true, // optional
        },
        time: {
          message: ':attribute must be a valid time',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(val, /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]+$/) &&
            params.indexOf(val) === -1,
          required: true, // optional
        },
        datePicker: {
          message: 'The :attribute must be a valid date with mm/dd/yyyy format',
          rule: (val, params) => moment(val).isValid() && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });
    this.validatorTime = new SimpleReactValidator({ locale: 'en' });
  }

  onDistributionListModify(value) {
    // event.preventDefault();
    // const { value } = event.currentTarget;
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      notificationData.distributionList = value;
      return { notificationData };
    });
  }

  onMailCCModify(value) {
    // event.preventDefault();
    // const { value } = event.currentTarget;
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      notificationData.mailCC = value;
      return { notificationData };
    });
  }

  onResponsibleEmailModify(value) {
    // event.preventDefault();
    // const { value } = event.currentTarget;
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      notificationData.responsibleEmail = value;
      return { notificationData };
    });
  }

  onMailBodyModify(value) {
    // event.preventDefault();
    // const { value } = event.currentTarget;
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      notificationData.mailBody = value;
      return { notificationData };
    });
  }

  onAuditorChanged(value) {
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.auditor = value;
      return { selectedActivity };
    });
  }

  onWorkSiteChanged(value) {
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.workSite = value;
      selectedActivity.idWorkSite = value?.id;
      return { selectedActivity };
    });
  }

  onTimeToChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.to = value;
      selectedActivity.time = `${selectedActivity.from} - ${value}`;
      return { selectedActivity };
    });
  }

  onTimeFromChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.from = value;
      selectedActivity.time = `${value} - ${selectedActivity.to}`;
      return { selectedActivity };
    });
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  updateStatesTime = (inputName, inputValue, objName) => {
    if (inputValue == false) {
      this.setState({ flagTime: true });
      if (!this.validatorTime.allValid()) {
        this.validatorTime.showMessages();
      }
    } else {
      const statusCopy = { ...this.state };
      statusCopy[objName][inputName] = inputValue;
      statusCopy.flagTime = false;
      this.setState(statusCopy);
    }
  };

  onActivityChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.activity = value;
      return { selectedActivity };
    });
  }

  onDocumentNameChange(value) {
    this.setState((prevState) => {
      const selectedDocument = { ...prevState.selectedDocument };
      selectedDocument.name = value;
      return { selectedDocument };
    });
  }

  onActivityDateChange(e) {
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.date = moment(e[0]).format('YYYY-MM-DD');
      return { selectedActivity };
    });
  }

  onSubmitActivity(event) {
    event.preventDefault();
    if (
      this.validator.fieldValid('auditor') &&
      this.validator.fieldValid('date') &&
      this.validator.fieldValid('from') &&
      this.validator.fieldValid('to') &&
      this.validator.fieldValid('activity') &&
      this.validator.fieldValid('diffTIme')
    ) {
      if (!this.validatorTime.allValid()) {
        this.setState((prevState) => {
          const notificationData = { ...prevState.notificationData };
          const selectedActivity = { ...prevState.selectedActivity };
          selectedActivity.time = `${selectedActivity.from} - ${selectedActivity.to}`;

          
          const startDate = this.props.startDate ? moment(this.props.startDate).format('YYYY-MM-DD') : null;
          const endDate = this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : null;
          let selectedActivityDate = moment(selectedActivity.date).format('YYYY-MM-DD'); //RITM1091064 - Audit Report Start End Date Fix

          console.log("date", selectedActivityDate) //RITM1091064 - Audit Report Start End Date Fix
          console.log("sdate",startDate)
          console.log("edate",endDate)

          if(startDate !== null && endDate !== null){          
            if(selectedActivityDate >= startDate && selectedActivityDate <= endDate){ //RITM1091064 - Audit Report Start End Date Fix
              if (!selectedActivity.id) {
                selectedActivity.id = uuid();
                selectedActivity.idNotificationForm = prevState.notificationData.id;
                // notificationData.activities = prevState.notificationData.activities.concat(
                //   selectedActivity
                // );
                const notact = [selectedActivity];
                notificationData.activities = notact.concat(prevState.notificationData.activities);                
                this.handleActivityDetailVisibility(null);
              } else {
                notificationData.activities = prevState.notificationData.activities
                  .filter((item) => selectedActivity.id !== item.id)
                  .concat(selectedActivity);
                this.handleActivityDetailVisibility(null);
              }

              this.props.setActivitiesData(notificationData.activities || []);
              return { notificationData };
            }
            else{
              showNotification.error(
                `${entitiesLabels.ERROR}`,
                `The ActiviyDate must be within the range of ${startDate} and ${endDate}`
              );
              this.forceUpdate();
            }
          }
          else{
              showNotification.error(
                `${entitiesLabels.ERROR}`,
                `The StartDate and EndDate must be requested`
              );
              this.forceUpdate();
          }
          
        });
      } else {
        this.validator.showMessages();
        showNotification.warning(
          `${entitiesLabels.WARNING}`,
          `${entitiesLabels.AUDIT} Time is invalid `
        );
        this.forceUpdate();
      }
    } else {
      this.validator.showMessageFor('auditor');
      this.validator.showMessageFor('from');
      this.validator.showMessageFor('date');
      this.validator.showMessageFor('to');
      this.validator.showMessageFor('activity');
      this.validator.showMessageFor('diffTIme');
      this.forceUpdate();
    }
  }

  onSubmitRelatedDocument(event) {
    event.preventDefault();
    if (this.validator.fieldValid('name')) {
      this.setState((prevState) => {
        const notificationData = { ...prevState.notificationData };
        const selectedDocument = { ...prevState.selectedDocument };
        if (!selectedDocument.id) {
          selectedDocument.id = uuid();
          selectedDocument.idNotificationForm = prevState.notificationData.id;
          notificationData.documents = prevState.notificationData.documents.concat(
            selectedDocument
          );
          this.handleRelatedDocumentModalVisibility(null);
        } else {
          notificationData.documents = prevState.notificationData.documents
            .filter((item) => selectedDocument.id !== item.id)
            .concat(selectedDocument);
          this.handleRelatedDocumentModalVisibility(null);
        }
        return { notificationData };
      });
    } else {
      this.validator.showMessageFor('name');
      this.forceUpdate();
    }
  }

  onActivityDelete() {
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      const selectedActivity = { ...prevState.selectedActivity };
      notificationData.activities = prevState.notificationData.activities.filter(
        (item) => selectedActivity.id !== item.id
      );
      return { notificationData };
    });
    this.handleDeleteActivityModal(null);
  }

  onRelatedDocumentDelete() {
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      const selectedDocument = { ...prevState.selectedDocument };
      notificationData.documents = prevState.notificationData.documents.filter(
        (item) => selectedDocument.id !== item.id
      );
      return { notificationData };
    });
    this.handleDeleteRelatedDocumentModal(null);
  }

  saveNotificationForm() {
    if (
      this.validator.fieldValid('distributionList') &&
      this.validator.fieldValid('responsible') &&
      this.validator.fieldValid('activities')
    ) {
      this.props.onSave(this.state.notificationData);
      this.setState({ validateSend: false });
    } else {
      this.validator.showMessageFor('distributionList');
      this.validator.showMessageFor('responsible');
      this.validator.showMessageFor('activities');

      this.forceUpdate();
    }
  }

  closeEditNotificationEmailModal = () => {
    this.setState({
      editNotificationEmailVisible: false,
    });
  };

  toggleModal = (open, property) => {
    this.setState({ [property]: open, editNotificationEmailVisible: false });
  };
  editNotificationEmailModal = () => {
    const modalSignatureProps = {
      key: `modalAuditSign_${new Date().getTime()}`,
      title: ' ',
      editModel: this.state.notificationData,
      isOpenModal: this.state.editNotificationEmailVisible,
      toggleModal: (open) => this.toggleModal(open, 'editNotificationEmailVisible'),
      save: this.sendNotification,
      idAudit: this.state.notificationData.idAudit,
      canEdit: this.props.isTeamLeader,
    };
    return (
      <div>
        {this.state.editNotificationEmailVisible ? (
          <AuditModalSignature {...modalSignatureProps} />
        ) : (
          ''
        )}{' '}
      </div>
    );
  };
  editNotificationEmail = (id) => {
    this.setState((oldState) => ({
      editNotificationEmailVisible: !oldState.editNotificationEmailVisible,
    }));
    this.editNotificationEmailModal();
  };

  sendNotification = (data) => {
    if (
      this.validator.fieldValid('distributionList') &&
      // this.validator.fieldValid('responsible') &&
      this.validator.fieldValid('activities')
    ) {
      this.props.onSend(data);
      this.setState({
        editNotificationEmailVisible: false,
        notificationData: data,
      });
    } else {
      this.validator.showMessageFor('distributionList');
      // this.validator.showMessageFor('responsible');
      this.validator.showMessageFor('activities');

      this.forceUpdate();
    }
  };

  handleActivityDetailVisibility(id) {
    const activity = this.state.notificationData.activities.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalActivityDetailVisible: !oldState.modalActivityDetailVisible,
      selectedActivity: activity || {},
    }));
  }

  handleDeleteActivityModal(id) {
    const activity = this.state.notificationData.activities.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalActivityDeleteVisible: !oldState.modalActivityDeleteVisible,
      selectedActivity: activity || {},
    }));
  }

  handleDeleteRelatedDocumentModal(id) {
    const document = this.state.notificationData.documents.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalDeleteRelatedDocumentVisible: !oldState.modalDeleteRelatedDocumentVisible,
      selectedDocument: document || {},
    }));
  }

  handleRelatedDocumentModalVisibility(id) {
    const document = this.state.notificationData.documents.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalRelatedDocumentDetailsVisible: !oldState.modalRelatedDocumentDetailsVisible,
      selectedDocument: document || {},
    }));
  }

  renderDeleteActivitiesModal = () =>
    this.state.modalActivityDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Team Activity</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteActivityModal}
              iconDescription=""
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">Press confirm to remove selected activity</h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeleteActivityModal}
            >
              Cancel
            </Button>
            <Button className="button--max-width" kind="primary" onClick={this.onActivityDelete}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderDeleteRelatedDocumentModal = () =>
    this.state.modalDeleteRelatedDocumentVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Related Document</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteRelatedDocumentModal}
              iconDescription=""
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">Press confirm to remove related document</h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeleteRelatedDocumentModal}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={this.onRelatedDocumentDelete}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderRelatedDocumentDetailModal = () => {
    const validationsModal = {
      name: this.validator.message('name', this.state.selectedDocument.name, 'required'),
    };
    return (
      this.state.modalRelatedDocumentDetailsVisible && (
        <div className="bx--modal bx--modal-tall is-visible box-medium-modal">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Add New Related Document</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={this.handleRelatedDocumentModalVisibility}
                iconDescription=""
              />
            </div>

            <div className="bx--modal-content information">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Name *">
                    <TextInput
                      labelText=""
                      id="inputDocumentName"
                      cols={250}
                      disabled={false}
                      invalid={validationsModal.name != null}
                      invalidText={validationsModal.name}
                      light
                      placeholder=""
                      rows={4}
                      value={this.state.selectedDocument.name || ''}
                      onChange={(e) => this.onDocumentNameChange(e.target.value)}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={this.handleRelatedDocumentModalVisibility}
              >
                Cancel
              </Button>
              <Button
                className="button--max-width"
                kind="primary"
                onClick={this.onSubmitRelatedDocument}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  renderNewActivityModal = () => {
    const validationsTime = {
      validTime: this.validatorTime.message('validTime', this.state.flagTime, 'accepted'),
    };
    let diffFromTo = false;
    if (this.state.selectedActivity.to != null) {
      const timeEnd = moment(this.state.selectedActivity.to, 'HH:mm a');
      const timeStart = moment(this.state.selectedActivity.from, 'HH:mm a');
      const duration = moment.duration(timeEnd.diff(timeStart));
      const minutes = parseInt(duration.asMinutes()) % 60;
      const hours = parseInt(duration.asHours());
      if (minutes >= 0 && hours >= 0) diffFromTo = true;
    }
    const validationsModal = {
      diffTIme: this.validator.message('diffTIme', diffFromTo, 'accepted'),
      auditor: this.validator.message('auditor', this.state.selectedActivity.auditor, 'required'),
      date: this.validator.message('date', this.state.selectedActivity.date, 'required|datePicker'),
      from: this.validator.message('from', this.state.selectedActivity.from, 'required'),
      to: this.validator.message('to', this.state.selectedActivity.to, 'required'),
      activity: this.validator.message(
        'activity',
        this.state.selectedActivity.activity,
        'required'
      ),
    };
    return (
      this.state.modalActivityDetailVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Add New Team Activity</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={this.handleActivityDetailVisibility}
                iconDescription=""
              />
            </div>

            <div className="bx--modal-content information">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Auditor*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputAuditor"
                      cols={250}
                      disabled={false}
                      invalid={validationsModal.auditor != null}
                      invalidText={validationsModal.auditor}
                      light
                      placeholder=""
                      rows={4}
                      value={this.state.selectedActivity.auditor || ''}
                      onChange={(e) => this.onAuditorChanged(e.target.value)}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="WorkSite">
                    <AuditWorkSiteComboBox
                      onChange={this.onWorkSiteChanged}
                      selectedItem={this.state.selectedActivity.workSite}
                      disabled={false}
                      items={this.props.workSites}
                    />
                  </FormGroup>
                </div>
              </div>

              <div className="bx--row">
                <div className="bx--col-lg-6 bx--col-md-12 paddingTopRow">
                  <DatePicker
                    dateFormat="d/m/Y"
                    datePickerType="single"
                    id="date-picker"
                    light
                    locale="en"
                    short={false}
                    onChange={(e) => this.onActivityDateChange(e)}
                  >
                    <DatePickerInput
                      value={
                        this.state.selectedActivity.date
                          ? moment(this.state.selectedActivity.date).format('DD/MM/Y')
                          : ''
                      }
                      className="some-class"
                      disabled={false}
                      iconDescription="Icon description"
                      id="date-picker-input-id"
                      invalid={validationsModal.date != null}
                      invalidText={validationsModal.date}
                      labelText="Activity Date*"
                      pattern="d{1,2}/d{4}"
                      placeholder="dd/mm/yyyy"
                      type="text"
                    />
                  </DatePicker>

                  {/*   <DateTimePicker
                    value={this.state.selectedActivity.date}
                    type="date"
                    placeholder={DateFormat}
                    name="date"
                    alt="selectedActivity"
                    invalid={validationsModal.date != null}
                    onChange={this.updateState}
                  /> */}
                </div>
                <div className="bx--col-lg-6 bx--col-md-12">
                  <div className="bx--row">
                    <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                      <FormGroup key="occurrenceTime" legendText="Time From*">
                        <DateTimePicker
                          className="pickerActivity"
                          id="time-pickerFrom"
                          value={this.state.selectedActivity.from || ''}
                          type="time"
                          placeholder="hh:mm AM/PM"
                          name="from"
                          alt="selectedActivity"
                          invalid={validationsModal.from != null}
                          onChange={this.updateStatesTime}
                          disabled={false}
                        />
                      </FormGroup>
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                      <FormGroup key="TimeTo" legendText="Time To*">
                        <DateTimePicker
                          className="pickerActivity"
                          value={this.state.selectedActivity.to || ''}
                          type="time"
                          placeholder="hh:mm AM/PM"
                          name="to"
                          id="time-pickerTo"
                          alt="selectedActivity"
                          invalid={validationsModal.to != null}
                          onChange={this.updateStatesTime}
                          disabled={false}
                        />
                      </FormGroup>
                    </div>
                    {validationsModal.diffTIme ||
                    validationsModal.to != null ||
                    validationsModal.to ? (
                      <div className="srv-validation-message "> Invalid time format </div>
                    ) : null}
                    {this.state.flagTime ? (
                      <div className="srv-validation-message "> Invalid time format </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12 paddingTopRow">
                  <FormGroup legendText="ACTIVITY and FUNCTION / PERSONNEL INVOLVED* (The mention of names and surnames must be done only if strictly necessary)">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputActivity"
                      cols={250}
                      disabled={false}
                      invalid={validationsModal.activity != null}
                      invalidText={validationsModal.activity}
                      light
                      placeholder=""
                      rows={4}
                      value={this.state.selectedActivity.activity || ''}
                      onChange={this.onActivityChanged}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={this.handleActivityDetailVisibility}
              >
                Cancel
              </Button>
              <Button className="button--max-width" kind="primary" onClick={this.onSubmitActivity}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  renderRelatedDocumentsDataTable = () => {
    const headers = [
      {
        key: 'name',
        header: 'Name',
        isSortable: true,
      },
    ];
    return (
      <DataTable
        useZebraStyles
        rows={this.state.notificationData.documents}
        headers={headers}
        render={({ rows, getHeaderProps }) => (
          <TableContainer>
            <TableToolbar>
              <TableToolbarContent className="table-toolbar-custom-content">
                <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                  <h6>List Of Related Documents</h6>
                </div>
                <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                  <Button
                    onClick={this.handleRelatedDocumentModalVisibility}
                    kind="primary"
                    renderIcon={Add16}
                    disabled={this.props.disabled}
                    iconDescription=""
                  >
                    Add New Document
                  </Button>
                </div>
              </TableToolbarContent>
            </TableToolbar>
            {this.renderDeleteRelatedDocumentModal()}
            {this.renderRelatedDocumentDetailModal()}
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                  ))}
                  <TableHeader className="align-center">Actions</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {!rows || rows.length < 1 ? (
                  <NoRecordsPlaceholder labelText="No Records" colSpan={headers.length + 1} />
                ) : (
                  rows.map((row) => (
                    <TableRow key={`row_${row.id}`}>
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                      <TableCell key="action" className="tableActions align-center">
                        <div>
                          <Button
                            onClick={() => this.handleRelatedDocumentModalVisibility(row.id)}
                            size="small"
                            renderIcon={Edit16}
                            iconDescription="Edit"
                            kind="ghost"
                            disabled={this.props.disabled}
                          />
                          <Button
                            onClick={() => this.handleDeleteRelatedDocumentModal(row.id)}
                            size="small"
                            renderIcon={Delete16}
                            iconDescription="Delete"
                            kind="ghost"
                            disabled={this.props.disabled}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    );
  };

  render() {
    const validations = {
      distributionList: this.validator.message(
        'distributionList',
        this.state.notificationData.distributionList,
        'required'
      ),
      responsibleEmail: this.validator.message(
        'responsible',
        this.state.notificationData.responsibleEmail, 
        'required'//'emails' vv
      ),
      activities: this.validator.message(
        'activities',
        this.state.notificationData.activities[0],
        'required'
      ),
    };

    const headers = [
      {
        key: 'auditor',
        header: 'Auditor',
        isSortable: true,
      },
      {
        key: 'workSite',
        header: 'WorkSite',
      },
      {
        key: 'activity',
        header: 'Activity',
      },
      {
        key: 'date',
        header: 'Date',
      },
      {
        key: 'time',
        header: 'Time From-TO',
      },
    ];
    return (
      <div>
        <Tile light>
          <DataTable
            useZebraStyles
            rows={
              this.state.notificationData.activities.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                const hA = moment(a.from, 'HH:mm a');
                const hB = moment(b.from, 'HH:mm a');
                dateA.setHours(hA.hours(), hA.minutes());
                dateB.setHours(hB.hours(), hB.minutes());
                return dateA - dateB;
              }) || []
            }
            headers={headers}
            render={({ rows, getHeaderProps }) => (
              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent className="table-toolbar-custom-content">
                    <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                      <h6>List Of Audit Activities</h6>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                                {!this.state.isDisabled && !this.props.maskedValue && ( //RITM1133680 Start - Anonimization AUDIT Module
                                    <Button
                                        onClick={this.handleActivityDetailVisibility}
                                        kind="primary"
                                        renderIcon={Add16}
                                        disabled={this.props.disabled}
                                        iconDescription=""
                                    >
                                        Add New Activity
                                    </Button>
                                )}
                    </div>
                  </TableToolbarContent>
                </TableToolbar>
                {this.renderDeleteActivitiesModal()}
                {this.renderNewActivityModal()}
                <Table>
                  <TableHead>
                    <TableRow>
                      {headers.map((header) => (
                        <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                      ))}
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!rows || rows.length < 1 ? (
                      <NoRecordsPlaceholder labelText="No Records" colSpan={headers.length + 1} />
                    ) : (
                      rows.map((row) => (
                        <TableRow key={`row_${row.id}`}>
                          {row.cells.map((cell) => (
                            <TableCell key={cell.id}>
                              {cell.info.header.includes('date')
                                ? moment(cell.value).format('DD/MM/YYYY')
                                : cell.info.header.includes('workSite')
                                ? cell.value?.name || 'N/A'
                                : cell.value}
                            </TableCell>
                            
                          ))}
                          <TableCell key="action" className="tableActions align-center">
                                  {!this.state.isDisabled && !this.props.maskedValue && ( //RITM1133680 Start - Anonimization AUDIT Module
                                      <div>
                                          <Button
                                              onClick={() => this.handleActivityDetailVisibility(row.id)}
                                              size="small"
                                              renderIcon={Edit16}
                                              iconDescription="Edit"
                                              kind="ghost"
                                              disabled={this.props.disabled}
                                          />
                                          <Button
                                              onClick={() => this.handleDeleteActivityModal(row.id)}
                                              size="small"
                                              renderIcon={Delete16}
                                              iconDescription="Delete"
                                              kind="ghost"
                                              disabled={this.props.disabled}
                                          />
                                      </div>
                                  )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
          {validations.activities}
        </Tile>
        <Tile light>
          <div className="bx--row">
            <div className="bx--col-lg-6 bx--col-md-12">
              <FormGroup legendText="Mail To* (Personal Email Addresses are not allowed)">
                <EmailChips
                  id="inputDistributionList"
                  invalid={validations.distributionList != null}
                  // invalidText={validations.distributionList}
                  value={this.state.notificationData.distributionList || ''}
                  disabled={this.props.disabled}
                  type="text"
                  title="&#9888; Do Not use Personal Accounts"
                  onChange={this.onDistributionListModify}
                  masked={this.props.maskedValue}
                                //RITM1133680 Start - Anonimization AUDIT Module
                />
              </FormGroup>
            </div>
            <div className="bx--col-lg-6 bx--col-md-12">
              <FormGroup legendText="Mail Cc (Personal Email Addresses are not allowed)">
                <EmailChips
                  id="inputDistributionList"
                  // invalid={validations.distributionList != null}
                  // invalidText={validations.distributionList}
                  value={this.state.notificationData.mailCC || ''}
                  disabled={this.props.disabled}
                  type="text"
                  title="&#9888; Do Not use Personal Accounts"
                  onChange={this.onMailCCModify}
                  masked={this.props.maskedValue}
                                //RITM1133680 Start - Anonimization AUDIT Module
                />
              </FormGroup>
            </div>
          </div>
          <div className="bx--col-lg-12 bx--col-md-12">
            <FormGroup legendText="E-Mail to Organization Representative* (Personal Email Addresses are not allowed)">
              <EmailChips
                id="inputResponsible"
                invalid={validations.responsibleEmail != null} 
                // invalidText={validations.distributionList}
                value={this.state.notificationData.responsibleEmail || ''}
                disabled={this.props.disabled}
                type="text"
                title="&#9888; Do Not use Personal Accountss"
                onChange={this.onResponsibleEmailModify}
                masked={this.props.maskedValue}
                            //RITM1133680 Start - Anonimization AUDIT Module
              />
              {/* <TextInput
                id="inputResponsible"
                invalid={validations.responsibleEmail != null}
                invalidText={validations.responsibleEmail}
                labelText=""
                onChange={this.onResponsibleEmailModify}
                onClick={() => {}}
                placeholder="provide valid email address"
                type="email"
                value={this.state.notificationData.responsibleEmail || ''}
                disabled={this.props.disabled}
              /> */}
            </FormGroup>
          </div>

          <div className="bx--col-lg-12">
            <FormGroup legendText="Message (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
              <TextArea
                maxLength={5000}
                id="mailBody"
                placeholder="Input message"
                value={this.state.notificationData.mailBody || ''}
                onChange={(el) =>
                  this.onMailBodyModify(el.target.value)
                }
                hideLabel={true}
                labelText=""
                light
                rows={4}
                cols={100}
                disabled={this.props.isDisabled}
              />
            </FormGroup>
          </div>

        </Tile>
        <Tile light>{this.renderRelatedDocumentsDataTable()}</Tile>
        <div className="bx--row table-toolbar-custon-content-info-end ">
          <Button
            size="default"
            renderIcon={Save16}
            kind="secondary"
            onClick={this.saveNotificationForm}
            disabled={this.props.disabled}
            iconDescription=""
          >
            Save
          </Button>

          <Button
            size="default"
            renderIcon={Send16}
            disabled={this.props.disabled || this.props.NotificationFormData?.savedOn == null}
            kind="primary"
            onClick={this.editNotificationEmail}
            iconDescription=""
          >
            Sign and Send
          </Button>
          {this.editNotificationEmailModal()}
        </div>
      </div>
    );
  }
}

AuditNotificationForm.propTypes = {
  id: PropTypes.string.isRequired,
  NotificationFormData: PropTypes.object.isRequired,
  minDate: PropTypes.string.isRequired,
  maxDate: PropTypes.string.isRequired,
  workSites: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
};
AuditNotificationForm.defaultProps = {
  disabled: true,
};
